import React, { useEffect, useState } from 'react'
import Modal from 'jd-library/Modal';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import Button from 'jd-library/Button';
import { useDispatch } from 'react-redux';
import styles from "./style.scss";
import { showToastMessage } from '../../../actions/toastmessage';
import withPortal from 'jd-library/withPortal';
import historyHandler from 'jd-library/historyHandler';


export default function useUpdateMRP(onMRPChange, initialMRP = 0, productData, isMRPModalVisible = false,isIPhone=false) {
    const [MRPModal, showMRPModal] = useState(isMRPModalVisible)
    const [mrp, setMRP] = useState(initialMRP)
    const [errorMsg, setErrorMsg] = useState('test');
    const dispatch = useDispatch();
    useEffect(() => {
        console.log("showMRPModal", MRPModal)
        if (MRPModal) {
            setMRP(() => initialMRP);
            setErrorMsg(() => '');
        }
    }, [MRPModal]);

    const priceRegex = /^\d{0,10}(\.\d{0,2})?$/;

    const initial_inputObj = {
        label: 'Product Price',
        key: 'mrp',
        holderClass: 'title-mrp',
        input: {
            className: 'title-mrp-input',
            value: mrp,
            type: isIPhone ? "text" : "tel",
            autoFocus: true,
            maxlength: 100,
            onKeyDown: (e) => {
                if (e.keyCode === 13) {
                    omMRPSubmit();
                }
            },
            onChange: (e) => {
                const { target:{ value } } = e;
                if (!priceRegex.test(value)) {
                    return;
                }
                if (errorMsg) {
                    setErrorMsg(() => '');
                }
                setMRP(() => value);
            }
        }
    }

    // const [inputObj, setInputObj] = useState(initial_inputObj)

    // useEffect(() => {
    //     inputObj.input.value=mrp
    //     setInputObj(inputObj)
    //     // console.log("showMRPModal useEffect", mrp,inputObj)
    // }, [mrp])


    // const _setMRP = (mrp) => {
    //     setMRP(mrp)
    //     inputObj.input.value = mrp
    //     setInputObj(inputObj)
    // }

    const omMRPSubmit = () => {
        if (mrp && Number(mrp) > 1) {
            onMRPChange(mrp);
            historyHandler.closeCurrent();
            showMRPModal(false);
        } else {
            if (!mrp) {
                dispatch(showToastMessage({
                    showToastMessage: true,
                    message: 'Mrp is required',
                    duration: 5000,
                    type: 'error'
                }));
                setErrorMsg('Mrp is required');
            } else if (Number(mrp) === 1 || Number(mrp) === 0) {
                setErrorMsg(Number(mrp) === 1 ? 'Cannot be 1' : 'Cannot be 0');
                dispatch(showToastMessage({
                    showToastMessage: true,
                    message: Number(mrp) === 1 ? 'Cannot be 1' : 'Cannot be 0',
                    duration: 5000,
                    type: 'error'
                }));
            }
        }
    }


    const getMRPField = () => {
        return (
            <div className={`${styles["update_mrp_form"]}`}>
                <InputWithMovingLabel
                    label={initial_inputObj.label}
                    holderClass={initial_inputObj.holderClass}
                    input={initial_inputObj.input}
                    key={initial_inputObj.key}
                    errorMessage={errorMsg}
                    prepend={() => <span>₹</span>}
                />

                <Button
                    className={`${styles["update_mrp_form_button"]}`}
                    block
                    size='lg'
                    children='Update MRP'
                    onClick={omMRPSubmit}
                />

            </div>
        )
    }

    const getUpdateMRPModal = () => <_getUpdateMRPModal
        productData={productData}
        MRPModal={MRPModal}
        showMRPModal={showMRPModal}
        getMRPField={getMRPField}
        isIPhone={isIPhone}
    />




    return {
        showMRPModal, getUpdateMRPModal: getUpdateMRPModal, mrp
    }
}


const _getUpdateMRPModal = withPortal(({ productData, MRPModal, showMRPModal, getMRPField,isIPhone }) => {
    return (
        <div className={styles["update_mrp"]}>
            {
                MRPModal &&
                <Modal
                    settings={{
                        modalId: 'basic-modal',
                        class: `${styles['update_mrp_modal']} ${isIPhone?"onIphone":""}`,
                    }}
                    onHidden={() => {
                        showMRPModal(false)
                    }}
                    backdropStatic
                >
                    <div className={styles['update_mrp_modal_content']}>
                        <Modal.CloseIcon />
                        <Modal.Header className={styles['update_mrp_modal_header']}>
                            <div className={styles['update_mrp_modal_title']}>
                                Edit Product MRP
                            </div>
                            <div className={styles['update_mrp_modal_short_description']}>
                                {productData?.productName}
                            </div>
                        </Modal.Header>
                        <Modal.Body className={styles['update_mrp_modal_body']}>
                            {getMRPField()}
                        </Modal.Body>
                        <Modal.Footer></Modal.Footer>
                    </div>
                </Modal>
            }

        </div>
    )
})